import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { clearResetRequired } from '../store/slices/authSlice';
import { apiFetch } from '../utils/streamApi';
import '../css/login.css';

export default function ChangePasswordPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [current, setCurrent] = useState('');
  const [next,    setNext]    = useState('');
  const [confirm, setConfirm] = useState('');
  const [error,   setError]   = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (next.length < 4) { setError('New password must be at least 4 characters'); return; }
    if (next !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true);
    try {
      const res = await apiFetch('/auth/ui/change-password', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ current_password: current, new_password: next }),
      });
      if (!res.ok) {
        const d = await res.json();
        setError(d.detail || 'Failed to change password');
        return;
      }
      dispatch(clearResetRequired());
      navigate('/', { replace: true });
    } catch {
      setError('Cannot reach server — check connection');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pk-login-root login-page">
      <div className="login-card">
        <div className="login-brand">
          <div className="login-logo">
            <svg width="36" height="36" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="14" cy="14" r="13" stroke="#1f8ef1" strokeWidth="1.5"/>
              <circle cx="14" cy="14" r="7"  stroke="#1f8ef1" strokeWidth="1.5"/>
              <circle cx="14" cy="14" r="2.5" fill="#1f8ef1"/>
              <line x1="14" y1="0"  x2="14" y2="6"  stroke="#1f8ef1" strokeWidth="1.5" strokeLinecap="round"/>
              <line x1="14" y1="22" x2="14" y2="28" stroke="#1f8ef1" strokeWidth="1.5" strokeLinecap="round"/>
              <line x1="0"  y1="14" x2="6"  y2="14" stroke="#1f8ef1" strokeWidth="1.5" strokeLinecap="round"/>
              <line x1="22" y1="14" x2="28" y2="14" stroke="#1f8ef1" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </div>
          <div className="login-brand-name">PARVEKSHAK</div>
          <div className="login-brand-sub">Set New Password</div>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-field">
            <label>Current Password</label>
            <div className="login-input-wrap">
              <span className="login-input-icon">🔒</span>
              <input className="login-input" type="password" placeholder="Enter current password"
                value={current} onChange={e => setCurrent(e.target.value)} autoFocus required />
            </div>
          </div>
          <div className="login-field">
            <label>New Password</label>
            <div className="login-input-wrap">
              <span className="login-input-icon">🔑</span>
              <input className="login-input" type="password" placeholder="Enter new password"
                value={next} onChange={e => setNext(e.target.value)} required />
            </div>
          </div>
          <div className="login-field">
            <label>Confirm New Password</label>
            <div className="login-input-wrap">
              <span className="login-input-icon">🔑</span>
              <input className="login-input" type="password" placeholder="Confirm new password"
                value={confirm} onChange={e => setConfirm(e.target.value)} required />
            </div>
          </div>

          {error && <div className="login-error"><span>⚠️</span> {error}</div>}

          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? 'Updating…' : 'Set New Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
